import { useSuspenseQuery } from '@tanstack/react-query';
import type { CreativeTextDetails } from '../types';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';

interface GetCreativeTextsParams {
  textId?: string;
}

export const getCreativeTextsDetails = async (
  { textId, ...params }: GetCreativeTextsParams,
  signal?: AbortSignal,
): Promise<CreativeTextDetails> => {
  const res = await apiClient.get<CreativeTextDetails>(
    `${queryKeys.creativeTexts}/${textId}`,
    {
      params,
      signal,
    },
  );
  return res.data;
};

interface UseOptions<TData> {
  config?: QueryConfig<typeof getCreativeTextsDetails, TData>;
  params: GetCreativeTextsParams;
}

export const useCreativeTextsDetails = <TData = CreativeTextDetails>
({
   params,
   config,
 }: UseOptions<TData>) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getCreativeTextsDetails(params, signal),
    queryKey: [queryKeys.creativeTexts, params],
  });
};
